import { Icon, Tooltip2 } from '@evertrue/et-components';
import PropTypes from 'prop-types';

const CONFIDENCE_INFO = {
  HIGH: {
    SCORE: 93,
    LABEL: 'High',
    CSS: 'high',
    ICON: 'human-verified',
    ICON_KIT: 'gt2',
    TOOLTIP:
      'This enrichment data was verified by a human and our confidence level regarding this piece of data is High',
  },
  MEDIUM: {
    SCORE: 79,
    LABEL: 'Medium',
    CSS: 'med',
    ICON: 'human-verified',
    ICON_KIT: 'gt2',
    TOOLTIP:
      'This enrichment data was verified by a human and our confidence level regarding this piece of data is Medium',
  },
  LOW: {
    SCORE: 0,
    LABEL: 'Low',
    CSS: 'low',
    ICON: 'alert-circle',
    ICON_KIT: null,
    TOOLTIP: 'Our confidence level regarding this piece of enrichment data is Low',
  },
};

const EnrichmentConfidencePill = ({ score }) => {
  if (!score && score !== 0) {
    return <span className="profile--enrichment--pill-na">-</span>;
  }

  const confidence_info =
    score >= CONFIDENCE_INFO.HIGH.SCORE
      ? CONFIDENCE_INFO.HIGH
      : score >= CONFIDENCE_INFO.MEDIUM.SCORE
        ? CONFIDENCE_INFO.MEDIUM
        : CONFIDENCE_INFO.LOW;

  return (
    <Tooltip2
      trigger={
        <div className={`profile--enrichment--pill profile--enrichment--pill-${confidence_info.CSS}`}>
          {confidence_info.ICON_KIT ? (
            <Icon icon={confidence_info.ICON} iconKit={confidence_info.ICON_KIT} />
          ) : (
            <Icon icon={confidence_info.ICON} />
          )}
          <span className="profile--enrichment--pill-label">{confidence_info.LABEL}</span>
        </div>
      }
    >
      {confidence_info.TOOLTIP}
    </Tooltip2>
  );
};

EnrichmentConfidencePill.propTypes = {
  score: PropTypes.number,
};

export default EnrichmentConfidencePill;
